import { useAppliedFilters } from '@zen/utils/Filtering/contexts/FiltersContext';
import { usePagination } from '@zen/utils/hooks/pagination';

import type { GetWorkflowRulesQueryResult, GetWorkflowRulesQueryVariables } from '../graphql';
import { useGetWorkflowRulesQuery } from '../graphql';
import type { WorkflowRuleFilters, WorkflowRulesListItem } from '../types';

export const useWorkflowRules = (workflowRuleDefinitionId: string, accountIds?: string[]) => {
  const {
    appliedFilters: { ruleInputFilters, ruleOutputFilters }
  } = useAppliedFilters<WorkflowRuleFilters>();

  return usePagination<GetWorkflowRulesQueryResult, GetWorkflowRulesQueryVariables, WorkflowRulesListItem>(
    useGetWorkflowRulesQuery,
    'workflowRules',
    {
      workflowRuleDefinitionId,
      workflowRulesInputObjectFiltersInput: accountIds ? { accountId: accountIds } : ruleInputFilters,
      workflowRulesOutputObjectFiltersInput: ruleOutputFilters
    },
    20,
    {
      fetchPolicy: 'no-cache',
      nextFetchPolicy: 'no-cache',
      skip: !workflowRuleDefinitionId
    }
  );
};
